import type { Settings } from '../types.js';

export function resolvedTheme(theme: Settings['theme'], prefersDark?: boolean): 'light' | 'dark' {
  if (theme !== 'system') return theme;
  const systemPrefersDark = prefersDark ?? window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  return systemPrefersDark ? 'dark' : 'light';
}

export function applyTheme(theme: Settings['theme']): void {
  const resolved = resolvedTheme(theme);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.style.colorScheme = resolved;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', resolved === 'dark' ? '#0b1714' : '#f3f5f2');
}
